// SidebarContext.js
import React, { createContext, useState, useContext } from 'react';

// Create context
const SidebarContext = createContext();
const mql = window.matchMedia(`(min-width: 800px)`);

// Provider component
export const SidebarProvider = ({ children }) => {
  const [sidebarDocked, setSidebarDocked] = useState(mql.matches);

  return (
    <SidebarContext.Provider value={{ sidebarDocked, setSidebarDocked }}>
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to consume the context
export const useSidebarDocked = () => {
  return useContext(SidebarContext);
};

export default SidebarContext;
